import React from 'react'
import { TextInput, type TextInputProps } from '@mantine/core'

export type AppInputProps = TextInputProps;

export default function AppInput (props: AppInputProps) {
  return <TextInput radius="sm" {...props} />
}
